export default "__VITE_ASSET__BlYgn__M__"